<template xmlns:v-scroll="http://www.w3.org/1999/xhtml">
  <div id="map_item_list" class='map-item-list' :class="[mapItemListClass]" v-resize="onResize" shrink>
    <!-- div style="position: fixed; background-color: #fff; top:0; right:0;">{{log}}</div -->
    <div class="list-wrap">
      <div class="list-tab-line">
        <v-layout row >
          <!-- 탭 -->
          <v-flex grow>
            <v-tabs
              v-model="mapData.filterState.viewType"
              color="transparent"
              grow
              style="position: relative;"
            >
              <div class="title-line-under-bar"></div>
              <v-tabs-slider color="title_dark1" style="position: relative; z-index:1;"></v-tabs-slider>
              <v-tab href="#tab-1">
                전체매물
              </v-tab>
              <v-tab href="#tab-2">
                공실매물
              </v-tab>
              <v-tab href="#tab-3" >
                건물정보
              </v-tab>
            </v-tabs>
          </v-flex>
          <v-flex shrink class="hidden-md-and-up title-line-updown-btn" @click="clickListUpdownBtn()">
            <v-icon v-if="mapItemListClass == 'map-item-list-close' || mapItemListClass == 'map-item-list-open'">keyboard_arrow_up</v-icon>
            <v-icon v-if="mapItemListClass == 'map-item-list-fullopen'">keyboard_arrow_down</v-icon>
          </v-flex>
        </v-layout>
      </div>
      <div class="list-area scroll-y" id="scroll-target">
        <div id="list_scroll_area" class="scroll-area">
          <!-- 리스트 -->
          <div v-scroll:#list_scroll_area="onScroll" id="item_list_wrap" class="item_list_wrap">
            <div class="list-tot-count">
              {{(mapData.filterState.viewType === 'tab-3' && !auth.isStaff && !auth.isPlusMember && !auth.isPartner) ? (!mapData.filterState.target.selected) ? '화면 내 전체' : '' : '조건에 맞는'}} <span v-if="mapData.filterState.target.selected">선택범위 내 </span><span v-if="mapData.filterState.viewType !== 'tab-3'">매물</span><span v-if="mapData.filterState.viewType === 'tab-3'">건물</span> <span class="num">{{(mapData.filterState.target.selected) ? mapData.filterState.target.totCount : mapData.filterState.totCount}}</span>개
            </div>
            <div class="no-item-list" v-if="mapData.itemListData.length === 0">
              <v-layout class="fill-height wrap align-center justify-center">
                <v-flex class="shrink mr-2"><v-icon>error_outline</v-icon></v-flex><v-flex class="shrink text-xs-center">준비중입니다.</v-flex>
              </v-layout>
            </div>
            <div id="map_list_view" class="map-list-view">
              <div v-if="mapData.itemListData.length > 0" v-for="(item, i) in mapData.itemListData" :key="i">
                <!-- 배너 -->
                <v-layout class="list-banner" v-if="manager.isWaiting &&((i > 0 && (i % 20) == 0) || i === 2)">
                  <v-flex class="find-room">
                    <router-link :to="{ path: 'modal', query: { request: 1 }}"><img :src="`${$utile.getStaticUrl()}/map/map-list-banner-1.jpg`" style="width: 100%; height: auto;" ></router-link>
                  </v-flex>
                  <!--
                  <v-flex class="find-room">
                    <div class="title-area">하우스북, 내 방좀 찾아줘!</div>
                    <div class="desc-area">한방에 딱 맞는 방을 찾아드립니다.</div>
                    <div class="profile-name">찾을필요 없는 방 매칭 서비스--><!--<span class="point">{{manager.m_name}}</span>{{manager.m_jobGrade}}님--><!--</div>
                    <div class="profile-img">
                      <img :src="`${$utile.getStaticUrl()}/item-list-banner-img.jpg`" > -->
                      <!--
                      <img :src="manager.m_profile_img" v-if="manager.m_profile_img !== ''">
                      <div class="no-img" v-if="manager.m_profile_img === ''">
                        <v-icon>camera</v-icon>
                      </div>
                      -->
                  <!--</div>-->
                  <!--<div class="state"><span>담당자대기</span></div>-->
              <!--</v-flex>-->
                </v-layout>
                <v-layout class="list-item" @mouseenter="listMouseOver(item.over_move_lat, item.over_move_lng, mapData)" @mouseleave="listMouseOut(item.over_move_lat, item.over_move_lng, mapData)">
                  <v-flex shrink class="title-img">
                    <!-- 매물 플로트 정보 -->
                    <div v-if="mapData.filterState.viewType !== 'tab-3'">
                      <div class="favorite" @click="toggleFavorite(item.no)">
                        <v-icon v-if="isFavorite(item.no)" class="active">favorite</v-icon>
                        <v-icon v-if="!isFavorite(item.no)">favorite_border</v-icon>
                      </div>
                      <v-icon v-if="item.isvideo === 1" class="play-bt">play_circle_outline</v-icon>
                      <v-layout class="img-tag-line">
                        <v-flex class="tag" v-if="item.isvideo === 1">#동영상</v-flex>
                        <v-flex class="tag" v-if="item.img2dCount > 0">#2D</v-flex>
                        <v-flex class="tag" v-if="item.img3dCount > 0">#3D</v-flex>
                        <v-flex class="tag" v-if="item.imgVRCount > 0">#VR</v-flex>
                      </v-layout>
                    </div>
                    <router-link :to="{ path: 'map', query: { no: ((mapData.filterState.viewType === 'tab-3') ? 'b' : 'r') + item.no }}">
                      <img v-if="item.imgurl !== ''" :src="item.imgurl"/>
                      <div v-if="item.imgurl === ''" class="no-img"><v-icon>camera_alt</v-icon> 촬영준비중</div>
                    </router-link>
                  </v-flex>
                  <!-- 매물 -->
                  <v-flex glow class="list-info" v-if="mapData.filterState.viewType !== 'tab-3'">
                    <router-link :to="{ path: 'map', query: { no: ((mapData.filterState.viewType === 'tab-3') ? 'b' : 'r') + item.no }}">
                      <div class="price-line"><span :class="getPriceTextColor(item.price)">{{item.price}}</span></div>
                      <div class="addr-line">{{item.addr}}</div>
                      <div class="info-line"><span class="mr-2" v-if="auth.isStaff || auth.isPlusMember || auth.isPartner">{{item.name}}호</span><span class="mr-2">{{item.struct}}</span><span class="point mr-2">{{item.itemtype}}</span></div>
                      <div class="info-line"><span class="mr-2">{{item.floor}}</span><span>{{getMCostText(item.mtype, item.mcost)}}</span></div>
                      <div class="tag-line">
                        <span v-if="item.tag.length > 0 && tag !== '' && index <= 2" v-for="(tag, index) in item.tag" :key="tag" class="tag">
                          #{{tag}}
                        </span>
                      </div>
                    </router-link>
                  </v-flex>
                  <!-- 건물 -->
                  <v-flex glow class="list-info" v-if="mapData.filterState.viewType === 'tab-3'">
                    <router-link :to="{ path: 'map', query: { no: ((mapData.filterState.viewType === 'tab-3') ? 'b' : 'r') + item.no }}">
                      <div class="match-line"><span class="point">{{item.name}} </span><span v-if="auth.isStaff">매칭 <span class="point">{{item.matchcount}}</span>개</span></div>
                      <div class="addr-line">{{item.addr}}</div>
                      <div class="info-line"><span class="mr-2">{{item.structuse}}</span><span class="mr-2">{{item.landuse}}</span></div>
                      <div class="info-line"><span class="mr-2">총 {{item.itemcount}}세대</span><span class="mr-2">{{printTotalFloor(item.under_floor, item.floor)}}</span></div>
                      <div class="approval-line">준공년도 : <span class="point">{{item.approval_date}}</span></div>
                      <!--<div class="tag-line">
                        <span v-if="item.tag.length > 0 && tag !== '' && index <= 2" v-for="(tag, index) in item.tag" :key="tag" class="tag">
                          #{{tag}}
                        </span>
                      </div>-->
                    </router-link>
                  </v-flex>
                </v-layout>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventBus from '@/utile/eventBus'
import Utile from '@/utile/utile'
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  name: 'MapItemList',
  data: () => ({
    itemListTabs: null,
    mapItemListClass: '',
    activeMap: false,
    mapListHeight: 0,
    log: ''
  }),
  components: {
  },
  computed: {
    ...mapState({
      mapData: state => state.mapData,
      auth: state => state.auth,
      manager: state => state.manager
    }),
    ...mapGetters({
      isFavorite: 'mapData/isFavorite'
    })
  },
  mounted () {
    this.onResize()
  },
  methods: {
    ...mapMutations({
      //
    }),
    ...mapActions({
      toggleFavorite: 'mapData/toggleFavorite',
      requestMapData: 'mapData/requestMapData'
    }),
    printTotalFloor (underfloor, floor) {
      return `${((underfloor * 1) > 0) ? '지하 ' + underfloor : '지상 1'}층 ~ 지상 ${floor}층`
    },
    getMCostText (mtype, mcost) {
      let val = ''
      if (mcost.indexOf('없음') !== -1) {
        return '관리비 없음'
      }
      if (mtype === '1') {
        val += '순수관리비 '
      } else if (mtype === '2') {
        val += '평당관리비 '
      }
      val += mcost
      return val
    },
    getPriceTextColor (text) {
      if (text.indexOf('전세') !== -1) {
        return 'color-2'
      }
      return 'color-1'
    },
    getThis: () => {
      return this
    },
    listMouseOver: (lat, lng, mapData) => {
      // console.log(`over! ${lat} / ${lng}`)
      if (!mapData.filterState.target.selected) {
        mapData.itemListOverUpdateCancel = true // 리스트 업데이트 한번 캔슬
      }
      mapData.itemListOverMarkerId = Utile.getMarkerId(lat, lng)
      EventBus.$emit('itemListOverMoveCenter', lat, lng)
    },
    listMouseOut: (lat, lng, mapData) => {
      mapData.itemListOverMarkerId = null
    },
    findRoom: () => {
      EventBus.$emit('findRoom', 0)
    },
    onScroll (e) {
      // this.log = `log: ${Math.round(e.target.scrollTop)} / ${Math.round(e.target.scrollHeight - e.target.clientHeight)}`
      // 오픈 상태일때 스크롤시 풀로 전환
      if (e.target.scrollTop > 100 && window.innerWidth <= 960 && this.mapItemListClass === 'map-item-list-open') {
        this.mapItemListClass = 'map-item-list-fullopen'
      }
      if (Math.round(e.target.scrollHeight - e.target.clientHeight) === Math.round(e.target.scrollTop)) {
        // console.log(`스크롤!`)
        this.requestMapData({ 'type': 'requestItemList', 'level': this.mapData.mapObject.getLevel(), 'bounds': this.mapData.mapObject.getBounds() }).then(data => {
          if (data.array.length > 0) {
            this.mapData.filterState.listCount = this.mapData.filterState.listCount + data.array.length
            this.mapData.filterState.target.listCount = this.mapData.filterState.target.listCount + data.array.length
            const _this = this
            data.array.forEach(function (value) {
              _this.mapData.itemListData.push(value)
            })
          }
        })
      }
    },
    setActiveMap (f) {
      if (f) {
        this.activeMap = true
        if (this.$vuetify.breakpoint.smAndDown) { // 960px 이하
          this.mapItemListClass = 'map-item-list-close'
        }
      } else {
        this.activeMap = false
        if (this.$vuetify.breakpoint.smAndDown) { // 960px 이하
          this.mapItemListClass = 'map-item-list-open'
        }
      }
    },
    openItemList () {
      this.activeMap = false
      if (this.$vuetify.breakpoint.smAndDown) { // 960px 이하
        this.mapItemListClass = 'map-item-list-open'
      }
    },
    onResize () {
      if (window.innerWidth <= 960) { // 960px 이하 sm 영역 this.$vuetify.breakpoint.smAndDown vuetify 반응이 느림
        this.mapItemListClass = 'map-item-list-open'
      } else {
        this.mapItemListClass = 'map-item-list-desktop'
      }
      // this.mapListHeight = window.innerHeight - document.getElementById('map_top_bar').offsetHeight
    },
    clickListUpdownBtn () {
      if (this.mapItemListClass === 'map-item-list-desktop') {
        this.mapItemListClass = 'map-item-list-open'
      } else if (this.mapItemListClass === 'map-item-list-close' || this.mapItemListClass === 'map-item-list-open') {
        this.mapItemListClass = 'map-item-list-fullopen'
      } else if (this.mapItemListClass === 'map-item-list-fullopen') {
        if (this.activeMap) {
          this.mapItemListClass = 'map-item-list-close'
        } else {
          this.mapItemListClass = 'map-item-list-open'
        }
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/layout/map/MapItemList.vue